// src/Other.js
import React from 'react';

const Other = () => {
    return (
        <div>
            <header className="pixelated-header">
                <h1>Other</h1>
            </header>
            <p className="SmallText">
                The developing took me like a month or something.. Thats pretty sure it!
                Now, here's some questions and answers for them.
            </p>
            <p className="MediumText">
                What's your future plans with the project?
            </p>
            <p className="SmallText">
                I'll put download links of the project here, will update the game regurally
                and it will look like really good 2D games! It was originally made for those
                who can't obtain any other cool card games. Also for pixel game enjoyers.
                I'm not gotta stop on this project: will make a trailer and will promote it.
            </p>
            <p className="MediumText">
                Will you put source code of this project here?
            </p>
            <p className="SmallText">
                I think I'll find another way how you can play it WITHOUT running it with the code.
                I heard about special extensions like .NET XNI or something else which already
                can do it.
            </p>
            <p className="MediumText">
                Will there be new cards?
            </p>
            <p className="SmallText">
                Currently in the game it's 12 official cards. I'll add new ones in the future if
                I'll want it.
            </p>
            <p className="MediumText">
                The cards aren't balanced well. What about that?
            </p>
            <p className="SmallText">
                I will think about it later.
            </p>
            <p className="MediumText">
                Report bugs that occur when the game is running on our email: kinsoobiao@gmail.com!
            </p>
        </div>
    );
};

export default Other;